export const enum CollectionsActionType {
  MoreNodesSelected = '[Collections] More Nodes Selected',
  VideoEndedEvent = '[Collections] Video Ended'
}

export class VideoEndedEvent {
  public readonly type = CollectionsActionType.VideoEndedEvent
}

export class MoreNodesSelected {
  public readonly type = CollectionsActionType.MoreNodesSelected
}

export type CollectionsAction = MoreNodesSelected | VideoEndedEvent

export const collectionsError = {
  invalidTabSelected: new Error('[Collections] - Invalid Tab Selected'),
  noMoreNodesAvailable: new Error('[Collections] - No More Nodes Available')
}
